import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface UnavailableReferenceRowProps {
  token: string;
  onRemove: () => void;
}

export function UnavailableReferenceRow(props: UnavailableReferenceRowProps) {
  const { token, onRemove } = props;
  const { t } = useTranslation("app");

  return (
    <div
      className="flex min-h-11 items-center justify-between gap-2 text-sm text-muted-foreground"
      data-testid={`creative-unavailable-reference-${token}`}
    >
      <span>{t("creativeLibrary.referenceNoLongerAvailable")}</span>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onRemove}
        data-testid={`creative-unavailable-reference-remove-${token}`}
      >
        {t("creativeLibrary.remove")}
      </Button>
    </div>
  );
}
